var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / CAF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-CAF",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#19BFBF",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05455613,5.66067012 C8.02442561,5.47988701 8.10128021,5.23205312 8.23664888,5.09668446 L10.4300178,2.90331554 C10.5607154,2.77261798 10.8236033,2.66666667 10.996926,2.66666667 L12.3364073,2.66666667 C12.5188045,2.66666667 12.7330265,2.79938634 12.8146216,2.96257655 L13.1853784,3.70409012 C13.2670916,3.86751663 13.4767049,4 13.660319,4 L15.6730143,4 C15.8536035,4 16.0665436,4.13308716 16.1503251,4.30065012 L17.8496749,7.69934988 C17.9326972,7.86539436 18.1569366,8 18.3302593,8 L19.6697407,8 C19.8521379,8 19.9140625,8.11458333 19.8009205,8.26543935 L18.1990795,10.4012273 C18.0891309,10.5478254 17.9336402,10.7993863 17.8520451,10.9625765 L17.4812883,11.7040901 C17.399575,11.8675166 17.3333333,12.14269 17.3333333,12.3364563 L17.3333333,12.996877 C17.3333333,13.1826967 17.2669735,13.466053 17.1853784,13.6292432 L16.8146216,14.3707568 C16.7329084,14.5341833 16.6003068,14.7993863 16.5187117,14.9625765 L16.1479549,15.7040901 C16.0662417,15.8675166 15.9336402,16.1327197 15.8520451,16.2959099 L15.4812883,17.0374235 C15.399575,17.20085 15.1906433,17.3333333 14.996877,17.3333333 L14.3364563,17.3333333 C14.1506366,17.3333333 13.9336402,17.2006137 13.8520451,17.0374235 L13.4812883,16.2959099 C13.399575,16.1324834 13.3333333,15.8480797 13.3333333,15.6589622 L13.3333333,12.3410378 C13.3333333,12.1526878 13.2291667,11.8958333 13.0926514,11.759318 L12.9073486,11.5740153 C12.7744237,11.4410903 12.6187216,11.1894983 12.5625,11.0208333 L12.1041667,9.64583333 C12.046637,9.47324435 11.8567708,9.33333333 11.6682008,9.33333333 L8.99846586,9.33333333 C8.81521822,9.33333333 8.64134661,9.18141301 8.61211054,9.00599655 L8.05455613,5.66067012 Z",
    id: "Rectangle-1072",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6666667,13.660319 C18.6666667,13.4797298 18.8093567,13.3333333 19.003123,13.3333333 L19.6635437,13.3333333 C19.8493634,13.3333333 20,13.4760234 20,13.6697896 L20,14.3302104 C20,14.5160301 19.9336402,14.7993863 19.8520451,14.9625765 L19.4812883,15.7040901 C19.399575,15.8675166 19.1787109,16 19,16 L19,16 C18.8159051,16 18.6666667,15.8566284 18.6666667,15.6730143 L18.6666667,13.660319 Z",
    id: "Rectangle-1073",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaf);
export default __webpack_public_path__ + "static/media/CAF.43be8578f6bd1bb151044d5fc0127b76.svg";
export { ForwardRef as ReactComponent };